export enum ePublicRoutes {
  LOGIN = '/login',
  RESET_PASSWORD = '/reset-password',
  SET_NEW_PASSWORD = '/set-new-password',
  VERIFY_EMAIL = '/verify-email',
  TRIAL_REGISTRATION_EMAIL = '/trial-registration-email',
  TRIAL_REGISTRATION_COMPANY = '/trial-registration-company/:email/:emailType/:language/:token',
  ACCESSIBILITY = '/accessibility',
  STATUS = '/status',
  LOGIN_MFA = '/login/mfa',
  CHANGE_EXPIRED_PASSWORD = '/login/change-expired-password',
  SSO_CALLBACK = '/sso-callback',
  REMOTE_SUPPORT_ESTABLISH = '/remote-support/establish',
}

export enum ePrivateRoutes {
  SAMPLES = '/samples',

  USER_CREATE = '/user/create',
  USER_EDIT = '/user/edit/:identity',
  USER_VIEW = '/user/view/:identity',
  USER = '/user/:identity/*',
  USER_OVERVIEW = '/user/:identity/overview',
  USER_RISK_HR = '/user/:identity/risk-hr',
  USERS = '/users',
  USERS_ARCHIVED = '/users/archived',
  USERS_BULK_UPLOAD = '/users/bulk-upload',
  PROFILE_EDIT = '/profile/edit',

  GENERAL_DASHBOARD = '/general-dashboard',
  MY_DASHBOARD = '/my-dashboard',
  DOCUMENTS = '/documents',

  RISKHR_DASHBOARD = '/riskhr/dashboard',
  RISKHR_REPORTS = '/riskhr/reports',
  RISKHR_ASSESSMENTS = '/riskhr/assessments',
  RISKHR_ASSESSMENTS_ARCHIVED = '/riskhr/assessments/archived',
  RISKHR_CASES = '/riskhr/cases',
  RISKHR_CASES_ARCHIVED = '/riskhr/cases/archived',
  RISKHR_CASE = '/riskhr/case/:caseId/*',
  RISKHR_REPORT = '/riskhr/report/:identity/:evaluationId',

  SETTINGS = '/settings/*',
  SUPPORT = 'support',

  EMORISK_DASHBOARD = '/emo/dashboard',
  EMORISK_REPORTS = '/emo/reports',
  EMORISK_RESULTS = '/emo/results',

  ACTIVITY_LOG = '/activity/log',
  ACTIVE_SESSIONS = '/security/active-sessions',
  REMOTE_SUPPORT = '/security/remote-support',

  PURCHASE = '/purchase/*',

  REPORTS = '/reports/*',
  REPORTS_CREATE = '/reports/create',
  REPORTS_DEFAULT = '/reports/default',
  REPORTS_CUSTOM = '/reports/custom',
  REPORTS_GENERATED = '/reports/generated',

  MESSAGE_CENTER = '/message-center',
}

export enum eSettingsRoutes {
  COMPANY_INFO = '/company-info',
  ADMIN_MANAGMENT = '/management-admins',
  PERMISSIONS = '/management-permissions',
  PERMISSIONS_LIST = '/management-permissions-list',
  PERMISSIONS_BY_ROLE = '/management-permissions-by-role',
  EMAIL = '/emails',
  EMAIL_BEHAVIOR = '/email-behavior',
  ORGANIZATION_EMAILS = '/organization-emails',
  UX_SETTINGS = '/ux',
  RISK_HR_ASSESSMENTS = '/modules-risk-hr-assessments',
  RISK_HR_SEVERITY_RULE = '/modules-risk-hr-severity-rules',
  RISK_HR_IMPACT_RULES = '/modules-risk-hr-impact',
  RISK_HR_SDG = '/modules-risk-hr-sdg',
  RISK_HR_NEW_IMPACT_RULES = '/modules-risk-hr-new-impact',
  RISK_HR_ASSESSMENT_LINKS = '/modules-risk-hr-assessment-links',
  RISK_HR_MITIGATION_POLICIES = '/modules-risk-hr-mitigation-policies',
  RISK_HR_TOPIC_ASSIGNMENTS = '/modules-risk-hr-topic-assignments',
  EMO_RISK = '/modules-emo-risk',
  PURCHASE_INVOICE = '/purchase-invoices',
  PURCHASE_TO_APPROVE = '/purchase-to-approve',
  PURCHASE_MY_REQUESTS = '/purchase-my-requests',
  ORGANIZATIONAL_STRUCTURE = '/organizational-structure/*',

  // Settings organization
  SETTINGS_DEPARTMENTS = '/departments',
  SETTINGS_POSITIONS = '/positions',
  SETTINGS_GROUPS = '/positions-groups',
  SETTINGS_EMPLOYEE_STATUS = '/employee-status',
  SETTINGS_POSITIONS_GROUPS_MAPPING = '/positions-groups-mapping',
  SETTINGS_ORGANIZATION = '/organization',
  ORGANIZATIONAL_STRUCTURE_MAIN = '/organizational-structure-main/*',
  ORGANIZATIONAL_STRUCTURE_GROUPS = '/organizational-structure-groups/*',
  ORGANIZATIONAL_STRUCTURE_BULK_UPLOAD = '/organizational-structure-bulk-upload',
  API_KEYS = '/api-keys',
  API_KEYS_DOCS = '/api-keys-docs',
  LICENSES = '/licenses',
  SSO = '/security-sso',
  SSO_AZURE_ENTRA = '/security-sso/azure-entra',
}

export enum eCasesRoutes {
  DETAILS = '/details',
  RISKS = '/:identity/:evaluationId/risks',
  COMPARISON = 'comparison',
  USER = 'user',
}

/**
 * `ePrivateRoutes` values are declared relative to the `/app` parent route, so they are only valid
 * as `<Route path>`. A router redirect resolves a leading slash against the domain root, so it must
 * carry the prefix or it lands on the 404 page.
 */
export const appPath = (route: ePrivateRoutes): string => `/app${route}`

/** Default landing page after successful admin login when no deep-link `from` path is stored. */
export const DEFAULT_AUTHENTICATED_LANDING_PATH = `/app${ePrivateRoutes.MY_DASHBOARD}`

export const resolvePostLoginPath = (from?: string): string => from || DEFAULT_AUTHENTICATED_LANDING_PATH
